// @ts-nocheck
// Call Stats — premium-minimal KPI tile: uppercase label (optionally with a
// small leading icon), big tabular number, small caption. `tone` picks one
// of the three semantic outcome colors (good/warn/crit); `color` overrides
// with any raw hex/css color for tiles that don't fit that vocabulary
// (Incoming/Outgoing/Talk Time/etc.) — the icon is tinted to match so the
// two read as one unit instead of a muted icon beside a colored number.
import React from 'react';
import { HAIRLINE } from '@/features/cti/ctiHelpers';

const TONE_TEXT = {
  good: 'text-success',
  warn: 'text-warning',
  crit: 'text-destructive',
};

export default function StatTile({ label, value, sub, tone, color, icon: Icon, compact = false }: any) {
  const toneClass = color ? '' : TONE_TEXT[tone] || 'text-foreground';
  const numberStyle = color ? { color } : undefined;
  const iconSize = compact ? 10 : 12;
  const labelRow = (
    <div className="flex min-w-0 items-center gap-1 text-muted-foreground">
      {Icon ? <Icon size={iconSize} className="shrink-0" style={color ? { color } : undefined} /> : null}
      <span
        className={`truncate font-semibold uppercase tracking-wide ${compact ? 'text-[9px]' : 'text-[10px] tracking-[0.08em]'}`}
      >
        {label}
      </span>
    </div>
  );

  if (compact) {
    return (
      <div className={`cti-kpi-card card-hover-raise rounded-xl border ${HAIRLINE} bg-muted/30 px-2.5 py-2`}>
        {labelRow}
        <div
          className={`num mt-1 truncate text-[16px] font-bold leading-none tabular-nums ${toneClass}`}
          style={numberStyle}
        >
          {value}
        </div>
        {sub ? <div className="mt-1 truncate text-[9px] text-muted-foreground">{sub}</div> : null}
      </div>
    );
  }

  return (
    <div className={`cti-kpi-card card-hover-raise rounded-2xl border ${HAIRLINE} bg-card p-3`}>
      {labelRow}
      <div
        className={`num mt-1.5 truncate text-[24px] font-bold leading-none tracking-tight tabular-nums ${toneClass}`}
        style={numberStyle}
      >
        {value}
      </div>
      {sub ? <div className="mt-1.5 truncate text-[10px] text-muted-foreground">{sub}</div> : null}
    </div>
  );
}
